import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CardFlipComponent } from './container/card/card.component';
import { CarouselComponent } from './container/carousel/carousel.component';
import { CubeRotateComponent } from './container/cube/cube.component';
import { ScreenItemComponent, ScreenSetComponent } from './container/screen/screen.set.component';
import { SliderImageComponent } from './container/slider/slider.image.component';
import { SliderSimpleComponent, SliderSimpleItemComponent } from './container/slider/slider.simple.component';
import { GraphComponent } from './graph/graph';
import { CellBorderedComponent } from './layout/cell-bordered/cell.bordered.component';
import { CellComponent } from './layout/cell/cell.component';
import { CellCustomComponent } from './layout/cell-custom/cell.custom.component';
import { SimpleColumnComponent } from './layout/column/column.component';
import { SimpleRowComponent } from './layout/row/row.component';
import { ScreenComponent } from './screen.component';

const components = [
  ScreenComponent,
  ScreenSetComponent,
  ScreenItemComponent,
  SimpleRowComponent,
  SimpleColumnComponent,
  CellComponent,
  CellBorderedComponent,
  CellCustomComponent,
  CubeRotateComponent,
  CardFlipComponent,
  CarouselComponent,
  SliderImageComponent,
  SliderSimpleComponent,
  SliderSimpleItemComponent,
  GraphComponent
];

@NgModule({
  imports: [CommonModule],
  declarations: [...components],
  exports: [...components]
})
export class ScreenModule {
}
